import styles from './stageUI.module.scss';

// Consistent header for every Create Listing stage: a title, an optional
// one-line description, and an optional "required fields" legend so users
// know what they're looking at and what's mandatory on the screen.
const StageHeader = ({title, description, showRequiredLegend = true}) => {
  return (
    <div className={styles['stage-header']}>
      <h1 className={styles['stage-title']}>{title}</h1>
      {description && (
        <p className={styles['stage-description']}>{description}</p>
      )}
      {showRequiredLegend && (
        <p className={styles['stage-legend']}>
          Fields marked <span className={styles['req-star']}>*</span> are
          required.
        </p>
      )}
    </div>
  );
};

export default StageHeader;
